/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SessionRenewedRouteImport } from './routes/session-renewed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShellUsersRouteImport } from './routes/_shell/users'
import { Route as ShellPartiesRouteImport } from './routes/_shell/parties'
import { Route as ShellOpenOrdersRouteImport } from './routes/_shell/open-orders'
import { Route as ShellEmailAddressesRouteImport } from './routes/_shell/email-addresses'
import { Route as ShellDashboardRouteImport } from './routes/_shell/dashboard'
import { Route as ShellProformasIndexRouteImport } from './routes/_shell/proformas/index'
import { Route as PProformaTokenRouteImport } from './routes/p/proforma/$token'
import { Route as ShellProformasNewRouteImport } from './routes/_shell/proformas/new'
import { Route as ShellProformasIdRouteImport } from './routes/_shell/proformas/$id'

const SessionRenewedRoute = SessionRenewedRouteImport.update({
  id: '/session-renewed',
  path: '/session-renewed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellUsersRoute = ShellUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPartiesRoute = ShellPartiesRouteImport.update({
  id: '/parties',
  path: '/parties',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOpenOrdersRoute = ShellOpenOrdersRouteImport.update({
  id: '/open-orders',
  path: '/open-orders',
  getParentRoute: () => ShellRoute,
} as any)
const ShellEmailAddressesRoute = ShellEmailAddressesRouteImport.update({
  id: '/email-addresses',
  path: '/email-addresses',
  getParentRoute: () => ShellRoute,
} as any)
const ShellDashboardRoute = ShellDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ShellRoute,
} as any)
const ShellProformasIndexRoute = ShellProformasIndexRouteImport.update({
  id: '/proformas/',
  path: '/proformas/',
  getParentRoute: () => ShellRoute,
} as any)
const PProformaTokenRoute = PProformaTokenRouteImport.update({
  id: '/p/proforma/$token',
  path: '/p/proforma/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellProformasNewRoute = ShellProformasNewRouteImport.update({
  id: '/proformas/new',
  path: '/proformas/new',
  getParentRoute: () => ShellRoute,
} as any)
const ShellProformasIdRoute = ShellProformasIdRouteImport.update({
  id: '/proformas/$id',
  path: '/proformas/$id',
  getParentRoute: () => ShellRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/session-renewed': typeof SessionRenewedRoute
  '/dashboard': typeof ShellDashboardRoute
  '/email-addresses': typeof ShellEmailAddressesRoute
  '/open-orders': typeof ShellOpenOrdersRoute
  '/parties': typeof ShellPartiesRoute
  '/users': typeof ShellUsersRoute
  '/proformas/$id': typeof ShellProformasIdRoute
  '/proformas/new': typeof ShellProformasNewRoute
  '/p/proforma/$token': typeof PProformaTokenRoute
  '/proformas/': typeof ShellProformasIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/session-renewed': typeof SessionRenewedRoute
  '/dashboard': typeof ShellDashboardRoute
  '/email-addresses': typeof ShellEmailAddressesRoute
  '/open-orders': typeof ShellOpenOrdersRoute
  '/parties': typeof ShellPartiesRoute
  '/users': typeof ShellUsersRoute
  '/proformas/$id': typeof ShellProformasIdRoute
  '/proformas/new': typeof ShellProformasNewRoute
  '/p/proforma/$token': typeof PProformaTokenRoute
  '/proformas': typeof ShellProformasIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_shell': typeof ShellRouteWithChildren
  '/login': typeof LoginRoute
  '/session-renewed': typeof SessionRenewedRoute
  '/_shell/dashboard': typeof ShellDashboardRoute
  '/_shell/email-addresses': typeof ShellEmailAddressesRoute
  '/_shell/open-orders': typeof ShellOpenOrdersRoute
  '/_shell/parties': typeof ShellPartiesRoute
  '/_shell/users': typeof ShellUsersRoute
  '/_shell/proformas/$id': typeof ShellProformasIdRoute
  '/_shell/proformas/new': typeof ShellProformasNewRoute
  '/p/proforma/$token': typeof PProformaTokenRoute
  '/_shell/proformas/': typeof ShellProformasIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/session-renewed'
    | '/dashboard'
    | '/email-addresses'
    | '/open-orders'
    | '/parties'
    | '/users'
    | '/proformas/$id'
    | '/proformas/new'
    | '/p/proforma/$token'
    | '/proformas/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/session-renewed'
    | '/dashboard'
    | '/email-addresses'
    | '/open-orders'
    | '/parties'
    | '/users'
    | '/proformas/$id'
    | '/proformas/new'
    | '/p/proforma/$token'
    | '/proformas'
  id:
    | '__root__'
    | '/'
    | '/_shell'
    | '/login'
    | '/session-renewed'
    | '/_shell/dashboard'
    | '/_shell/email-addresses'
    | '/_shell/open-orders'
    | '/_shell/parties'
    | '/_shell/users'
    | '/_shell/proformas/$id'
    | '/_shell/proformas/new'
    | '/p/proforma/$token'
    | '/_shell/proformas/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ShellRoute: typeof ShellRouteWithChildren
  LoginRoute: typeof LoginRoute
  SessionRenewedRoute: typeof SessionRenewedRoute
  PProformaTokenRoute: typeof PProformaTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/session-renewed': {
      id: '/session-renewed'
      path: '/session-renewed'
      fullPath: '/session-renewed'
      preLoaderRoute: typeof SessionRenewedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/users': {
      id: '/_shell/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof ShellUsersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/parties': {
      id: '/_shell/parties'
      path: '/parties'
      fullPath: '/parties'
      preLoaderRoute: typeof ShellPartiesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/open-orders': {
      id: '/_shell/open-orders'
      path: '/open-orders'
      fullPath: '/open-orders'
      preLoaderRoute: typeof ShellOpenOrdersRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/email-addresses': {
      id: '/_shell/email-addresses'
      path: '/email-addresses'
      fullPath: '/email-addresses'
      preLoaderRoute: typeof ShellEmailAddressesRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/dashboard': {
      id: '/_shell/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ShellDashboardRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/proformas/': {
      id: '/_shell/proformas/'
      path: '/proformas'
      fullPath: '/proformas/'
      preLoaderRoute: typeof ShellProformasIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/p/proforma/$token': {
      id: '/p/proforma/$token'
      path: '/p/proforma/$token'
      fullPath: '/p/proforma/$token'
      preLoaderRoute: typeof PProformaTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/proformas/new': {
      id: '/_shell/proformas/new'
      path: '/proformas/new'
      fullPath: '/proformas/new'
      preLoaderRoute: typeof ShellProformasNewRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/proformas/$id': {
      id: '/_shell/proformas/$id'
      path: '/proformas/$id'
      fullPath: '/proformas/$id'
      preLoaderRoute: typeof ShellProformasIdRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellRouteChildren {
  ShellDashboardRoute: typeof ShellDashboardRoute
  ShellEmailAddressesRoute: typeof ShellEmailAddressesRoute
  ShellOpenOrdersRoute: typeof ShellOpenOrdersRoute
  ShellPartiesRoute: typeof ShellPartiesRoute
  ShellUsersRoute: typeof ShellUsersRoute
  ShellProformasIdRoute: typeof ShellProformasIdRoute
  ShellProformasNewRoute: typeof ShellProformasNewRoute
  ShellProformasIndexRoute: typeof ShellProformasIndexRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellDashboardRoute: ShellDashboardRoute,
  ShellEmailAddressesRoute: ShellEmailAddressesRoute,
  ShellOpenOrdersRoute: ShellOpenOrdersRoute,
  ShellPartiesRoute: ShellPartiesRoute,
  ShellUsersRoute: ShellUsersRoute,
  ShellProformasIdRoute: ShellProformasIdRoute,
  ShellProformasNewRoute: ShellProformasNewRoute,
  ShellProformasIndexRoute: ShellProformasIndexRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ShellRoute: ShellRouteWithChildren,
  LoginRoute: LoginRoute,
  SessionRenewedRoute: SessionRenewedRoute,
  PProformaTokenRoute: PProformaTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
